import constants from '../Constants';
const {
  SIDEBAR_TOGGLE,
} = constants;

const INIT_STATE = {
  sidebar_toggle:true,
};

const LayoutReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIDEBAR_TOGGLE:
      return { ...state, sidebar_toggle: !action.payload };
    default:
        return state;
  }
}

export default LayoutReducer;


// WEBPACK FOOTER //
// ./src/Reducers/LayoutReducer.js